import {tags,data}from'./data/languages.js';const o=tags;var g=data;export{o as AvailableLanguageTags,g as default};